<template>
    <div class="flex flex-col">
        <h2 class="text-2xl md:text-4xl font-semibold mb-6">Referral for Testing</h2>

        <h4 class="font-semibold text-2xl">A suspected diagnosis was not clear at presentation; further investigation was required</h4>

        <ul class="list-disc pl-4  font-light">
            <li>The patient had a family history of kidney stones</li>
            <li>The authors state that as PH is a rare disease, it therefore was not initially suspected as a primary cause of the symptoms in this patient</li>
            <li>The patient was referred for diagnostic tests</li>

        </ul>

        <div class="my-6 md:my-12 flex flex-col md:flex-row md:flex-wrap md:justify-center gap-4 md:gap-6">
            <div
                class="h-64 md:min-w-80 flex-shrink basis-80 border-solid rounded-xl border-t-10 border-lightblue bg-grey p-6 flex flex-col items-center justify-center"
            >
                <img src="@/assets/img/graphics/pediatric/stethoscope.svg" alt="Stethoscope icon" />

                <h5 class="text-2xl text-center">Physical examination</h5>
            </div>

            <div
                class="h-64 md:min-w-80 flex-shrink basis-80 border-solid rounded-xl border-t-10 border-maroon bg-grey p-6 flex flex-col items-center justify-center"
            >
                <img src="@/assets/img/graphics/pediatric/beaker-maroon.png" alt="Beaker icon" />

                <h5 class="text-2xl text-center">Blood work</h5>
            </div>

            <div
                class="h-64 md:min-w-80 flex-shrink basis-80 border-solid rounded-xl border-t-10 border-darkerblue bg-grey p-6 flex flex-col items-center justify-center"
            >
                <img src="@/assets/img/kidneys.svg" alt="Kidneys icon" />

                <h5 class="text-2xl text-center">Urinalysis, urine cultures, and blood cultures</h5>
            </div>
        </div>
    </div>
</template>
